import { createSchema, Yup } from '@src/corelib/validation';


/**
 * Storefront form (M13). The single `slug` field is an optional string client-
 * side — validation (format, uniqueness, reserved names, required-when-enabling)
 * is server-driven, with 400 field errors mapped back onto the input via the
 * Form's `showServerErrors`. The `storefront_enabled` toggle is controlled
 * outside the form and merged into the PATCH payload at submit.
 */

const storefrontSchema = createSchema({ slug: Yup.string() });


/** Map a seller record onto the form's string-valued shape. */
function storefrontDefaults(seller) {
  return { slug: seller?.slug || '' };
}


/**
 * Build the public storefront URL preview for a slug. The base domain comes from the
 * seller record at runtime (single source of truth in Django settings); a neutral
 * placeholder stands in when either the slug or the base domain is absent.
 */
function storefrontUrl(slug, baseDomain) {
  const value = (slug || '').trim().toLowerCase();
  const domain = (baseDomain || '').trim() || 'your-domain';
  return `https://${value || 'your-slug'}.${domain}`;
}


export {
  storefrontDefaults,
  storefrontSchema,
  storefrontUrl,
};
